import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
  };

  useEffect(() => {
    setLanguage(i18n.language);
    if(i18n.language !== "nl" && i18n.language !== "fr" && i18n.language !== "en" && i18n.language !== "de") {
      setLanguage("nl");
    }
  }, [i18n.language]);

  return (
    <footer className="footer">
      <p>&copy; {currentYear} {t('footerText')}</p>
      <div className="language-switcher">
        <button
          onClick={() => changeLanguage("nl")}
          className={`lang-button ${language === "nl" ? "selected" : ""}`}
        >
          NL
        </button>
        <button
          onClick={() => changeLanguage("fr")}
          className={`lang-button ${language === "fr" ? "selected" : ""}`}
        >
          FR
        </button>
        <button
          onClick={() => changeLanguage("en")}
          className={`lang-button ${language === "en" ? "selected" : ""}`}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage("de")}
          className={`lang-button ${language === "de" ? "selected" : ""}`}
        >
          DE
        </button>
      </div>
    </footer>
  );
};

export default Footer;
